import { useDispatch } from 'react-redux';
import { SignupEmbedderOptions } from 'signup-embedder';
import { NextStepManager } from '../flow-management/NextStepManager';
import { setNextStep } from '../flow-management/setNextStep';
import { EndpointKey } from '../http/EndpointKey';
import { retryEndpoint } from '../store/http-responses/action-creators';
import { Step } from '../views/Step';
export const useEmailVerification = () => {
  const dispatch = useDispatch();
  const shouldEnforceEmailVerification = SignupEmbedderOptions.getOptionValue(SignupEmbedderOptions.SIGNUP_ENFORCE_EMAIL_VERIFICATION);
  const verificationStep = shouldEnforceEmailVerification ? Step.Verification : Step.CodeVerification;

  const resendEmail = () => {
    dispatch(retryEndpoint(EndpointKey.InitiateVerification, 1000));
    dispatch(setNextStep({
      rebuilder: NextStepManager.pushNextSteps(verificationStep)
    }));
  };

  return {
    resendEmail
  };
};